//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { forwardRef } from 'react';

import Button from '@components/atoms/button/Button';
import { DefaultButtonStyles } from '@components/atoms/button/buttonStyles';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

interface MediaLibrarySourcesButtonProps {
  isDisabled?: boolean;
  label: string;
  onClick?: () => void;
}

export const MediaLibrarySourcesButton = forwardRef<
  HTMLButtonElement,
  MediaLibrarySourcesButtonProps
>(({ isDisabled, label, onClick }, ref) => {
  return (
    <SmallTooltip
      content={'Select content sources for this Collection.'}
      interactive={false}
      target={
        <Button
          buttonStyles={DefaultButtonStyles}
          isDisabled={isDisabled}
          isDropdown={true}
          onClick={onClick}
          ref={ref}
          trackingId={MediaLibraryTrackingIds.TOGGLE_SOURCES_DROPDOWN}
        >
          {label}
        </Button>
      }
    />
  );
});
MediaLibrarySourcesButton.displayName = 'MediaLibrarySourcesButton';
